(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-user-practice-select-view2', [])
    .component('kUserPracticeSelectView2', {
      bindings: {
        choices: '<', // array of practices with {name, practiceGuid}
        currentPracticeGuid: '<',
        isCurrentUserMandatory: '<', // either current user or customer admin
        selections: '='
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-user-practice-select-view2.pug')()
    });

  controller.$inject = [];
  function controller() {
    const vm = this;

    vm.MAX_LENGTH = 48; // max practice name use to display expanded tooltip with it

    vm.$onInit = init;
    vm.handlePracticeSelection = handlePracticeSelection;
    vm.handleTooltipPracticeSelection = handleTooltipPracticeSelection;
    vm.handleSelectAll = handleSelectAll;

    function init() {
      vm.currentPracticeGuid = vm.currentPracticeGuid || '';
      Array.isArray(vm.choices) && vm.choices.forEach(practice => practice.selected = vm.selections.has(practice.practiceGuid));
      checkIfAllSelected();
    }

    function checkIfAllSelected() {
      vm.selectAll = vm.choices.length === vm.selections.size;
    }

    function handlePracticeSelection(practice) {
      addRemovePracticeSelection(practice);
      checkIfAllSelected();
    }

    function handleTooltipPracticeSelection(practice) {
      practice.selected = !practice.selected;
      handlePracticeSelection(practice);
    }

    function addRemovePracticeSelection(practice) {
      practice.selected? vm.selections.add(practice.practiceGuid) : vm.selections.delete(practice.practiceGuid);
    }

    function handleSelectAll(selectAll) {
      vm.choices.forEach(practice => {
        if (vm.isCurrentUserMandatory && practice.practiceGuid === vm.currentPracticeGuid) {
          return;
        }
        practice.selected = selectAll;
        addRemovePracticeSelection(practice);
      });
    }
    
  }
})();
